import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; 
import { 
  FiShield, FiList, FiLogOut, 
  FiDatabase, FiTerminal, FiAlertOctagon, FiGrid, FiTrendingUp
} from 'react-icons/fi';

const AdminSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth(); 

  // --- ROOT SECURITY GUARD ---
  // Absolute clearance granted only to the primary Root Owner email
  const isRootUser = user?.email === 'mtlhumaid@gmail.com';

  const menuItems = [
    { 
      name: 'Nexus Prime', 
      path: '/admin/dashboard', 
      icon: <FiGrid />,
      rootOnly: true 
    },
    { 
      name: 'Protocol Revenue', // ✅ NEW: Links to AdminRevenue.jsx
      path: '/admin/revenue', 
      icon: <FiTrendingUp />,
      rootOnly: true 
    },
    { 
      name: 'Dispute Center', 
      path: '/admin/disputes', 
      icon: <FiAlertOctagon />,
      rootOnly: false 
    },
    { 
      name: 'Trade Ledger', 
      path: '/admin/nexus', 
      icon: <FiList />,
      rootOnly: false 
    },
    { 
      name: 'Activity Log', 
      path: '/admin/audit', 
      icon: <FiDatabase />,
      rootOnly: true 
    },
    { 
      name: 'System Health', 
      path: '/admin/health', 
      icon: <FiTerminal />, 
      rootOnly: true 
    },
  ];

  return (
    <div className="fixed left-0 top-0 h-screen w-72 bg-[#0B1221] border-r border-white/5 p-8 flex flex-col justify-between z-50">
      <div>
        {/* BRANDING */}
        <div className="flex items-center gap-3 mb-16 px-2">
          <div className="w-10 h-10 bg-[#F25C05] rounded-xl flex items-center justify-center text-white shadow-lg shadow-[#F25C05]/20">
            <FiShield size={22} />
          </div>
          <div>
            <h2 className="text-white font-black uppercase tracking-tighter text-lg leading-none">Nexus</h2>
            <p className="text-[#F25C05] text-[8px] font-black uppercase tracking-[0.3em]">
              {isRootUser ? 'Root Master' : 'Admin Portal'}
            </p>
          </div>
        </div>

        {/* NAVIGATION */}
        <nav className="space-y-3">
          {menuItems.map((item) => {
            // SECURITY: Only show root-specific nodes to mtlhumaid@gmail.com
            if (item.rootOnly && !isRootUser) return null;

            const isActive = location.pathname === item.path;
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`w-full flex items-center gap-4 px-6 py-4 rounded-2xl font-black text-[10px] uppercase tracking-widest transition-all ${
                  isActive 
                  ? 'bg-[#F25C05] text-white shadow-lg shadow-[#F25C05]/20' 
                  : 'text-slate-500 hover:bg-white/5 hover:text-white'
                }`}
              >
                <span className={isActive ? 'text-white' : 'text-slate-500'}>{item.icon}</span>
                {item.name}
              </button>
            );
          })}
        </nav>
      </div>

      {/* FOOTER & IDENTITY STATUS */}
      <div className="space-y-4">
        <div className="px-6 py-4 bg-white/5 rounded-2xl border border-white/5">
          <p className="text-[8px] font-black text-slate-500 uppercase mb-1">Authenticated As</p>
          <p className="text-[10px] font-black text-white uppercase truncate">
            {isRootUser ? 'MTL HUMAID' : (user?.name || 'Admin_Session')}
          </p>
          <p className="text-[7px] font-bold text-[#F25C05] uppercase tracking-widest mt-1">
            {isRootUser ? 'Full Clearance (Root)' : 'Staff Access'}
          </p>
        </div>
        <button 
          onClick={() => navigate('/logout')}
          className="w-full flex items-center gap-4 px-6 py-4 rounded-2xl text-red-500 font-black text-[10px] uppercase tracking-widest hover:bg-red-500/10 transition-all"
        >
          <FiLogOut /> Terminate Session
        </button>
      </div>
    </div>
  );
};

export default AdminSidebar;